export const COMPUTER_TASKS_HREF = '/computer/tasks';
export const COMPUTER_TASK_THREAD_HREF_PREFIX = `${COMPUTER_TASKS_HREF}/`;
const TEAMMATE_COMPUTER_THREAD_ROUTE_PATTERN = /^(\/projects\/[^/]+)\/sessions\/[^/]+(?:\/)?$/;
const TEAMMATE_WORKSPACE_THREAD_ROUTE_PATTERN = /^\/workspace\/[^/]+\/sessions\/[^/]+(?:\/)?$/;
const TEAMMATE_SESSION_ROUTE_PATTERN = /^\/session\/[^/]+(?:\/)?$/;
export const isTeammateSessionRoute = (pathname) => pathname != null &&
    (TEAMMATE_COMPUTER_THREAD_ROUTE_PATTERN.test(pathname) ||
        TEAMMATE_WORKSPACE_THREAD_ROUTE_PATTERN.test(pathname) ||
        TEAMMATE_SESSION_ROUTE_PATTERN.test(pathname));
export const TEAMMATE_PROJECT_SESSION_SCOPE_QUERY_PARAM = 'sessionScope';
export const parseTeammateProjectSessionScope = (value) => (value === 'mine' ? 'mine' : 'all');
export const serializeTeammateProjectSessionScope = (scope) => (scope === 'all' ? undefined : scope);
// True when the page hosts a computer thread.
export const isComputerRoute = (pathname) => pathname != null && (pathname.startsWith('/computer') || isTeammateSessionRoute(pathname));
// A teammate session hosts a computer thread under /projects/:projectUuid/sessions/:sessionSlug.
// The teammate project collection is not distinguishable from a regular space collection by
// any collection field, so shared thread chrome derives the project link from the route it is
// rendered in: this returns the parent project path (/projects/:projectUuid) for those
// routes and null everywhere else, leaving regular space/project links untouched.
export const getTeammateProjectHrefForThreadRoute = (pathname, searchParams) => {
    const match = pathname?.match(TEAMMATE_COMPUTER_THREAD_ROUTE_PATTERN);
    const projectPath = match?.[1];
    if (!projectPath)
        return null;
    const sessionScope = parseTeammateProjectSessionScope(searchParams?.get(TEAMMATE_PROJECT_SESSION_SCOPE_QUERY_PARAM));
    const sessionScopeQueryValue = serializeTeammateProjectSessionScope(sessionScope);
    if (!sessionScopeQueryValue)
        return projectPath;
    const params = new URLSearchParams({
        [TEAMMATE_PROJECT_SESSION_SCOPE_QUERY_PARAM]: sessionScopeQueryValue,
    });
    return `${projectPath}?${params.toString()}`;
};
export const isComputerTaskThreadRoute = (pathname) => pathname?.startsWith(COMPUTER_TASK_THREAD_HREF_PREFIX) ?? false;
//# sourceMappingURL=constants.js.map